
  import {defineComponent} from 'vue';
  import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

  import ProductInfoComponent from '@/components/productDetail/ProductInfoComponent.vue';
  import ProductUsageComponent from "@/components/productDetail/ProductUsageComponent.vue";
  import ProductNoticeComponent from "@/components/productDetail/ProductNoticeComponent.vue";
  import ProductDetailImageComponent from "@/components/productDetail/ProductDetailImageComponent.vue";
  import OrderButtonComponent from '@/components/productDetail/OrderButtonComponent.vue';
  import TopButtonComponent from '@/components/shared/TopButtonComponent.vue';
  import AuthenticationPromptComponent from "@/components/shared/AuthenticationPromptComponent.vue";
  import CellphoneAuthenticationComponent from "@/components/shared/CellphoneAuthenticationComponent.vue";
  import router from "@/router";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";

  export default defineComponent({
    name: 'ProductDetailView',
    props: ['productId'],
    components: {
      HeaderComponent,
      ProductInfoComponent,
      ProductUsageComponent,
      ProductNoticeComponent,
      ProductDetailImageComponent,
      OrderButtonComponent,
      AuthenticationPromptComponent,
      CellphoneAuthenticationComponent,
      TopButtonComponent,
    },
    data() {
      return {
        showLoginPopup: false,
        showCertificationPopup: false,
      }
    },
    mounted(): void {
      window.vm.parentView = this;
      this.fetchProduct(this.productId);
    },
    computed: {
      loadingCompleted() : boolean {
        return this.product !== undefined && this.productId == this.product.productId;
      },
      showDimmed(): boolean {
        return this.showLoginPopup || this.showCertificationPopup;
      },
      ...mapState({
        product: (state: any) => state.ProductStore.product,
        authServer: (state: any) => state.AuthServerStore.authServer,
        nextView: (state: any) => state.NextViewStore.nextView,
      }),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    methods: {
      openLoginPopup(): void {
        let searchparams = new URLSearchParams();
        searchparams.append("redirect_uri", process.env.VUE_APP_API_SERVER_URL + process.env.VUE_APP_OAUTH_REDIRECT_PATH);
        searchparams.append("appYn", "N");

        window.open(process.env.VUE_APP_OAUTH_SERVER_URL + searchparams.toString());
      },
      openAuthenticationPromptPopup(): void {
        this.showLoginPopup = true;
      },
      closeAuthenticationPromptPopup(): void {
        this.showLoginPopup = false;
      },
      openCellphoneAuthenticationPopup(): void {
        this.showLoginPopup = false;
        this.showCertificationPopup = true;
      },
      closeCellphoneAuthenticationPopup(): void {
        this.showCertificationPopup = false;
      },
      saveToken(token: string): void {
        this.setToken(token);
      },
      moveToNextPage(): void {
        router.replace(this.nextView);
      },
      alertLoginFailed(): void {
        alert('일시적인 오류로 로그인이 실패하였습니다. 잠시 후, 다시 시도해주세요.');
      },
      ...mapMutations('MemberStore', [
        'setToken',
      ]),
      ...mapActions('ProductStore', [
          'fetchProduct'
      ])
    }
  });

